/** Quantities use the ledger's four-decimal scale. Keep strings until the API receives them. */
export function normalizeInventoryQuantity(value) {
  return String(value ?? "").trim().replace(",", ".");
}

export function isValidInventoryQuantity(value, { allowZero = false } = {}) {
  const quantity = normalizeInventoryQuantity(value);
  if (!/^\d+(?:\.\d{1,4})?$/.test(quantity)) return false;
  return allowZero ? Number(quantity) >= 0 : Number(quantity) > 0;
}
